(ns quuppa.ui.breadcrumbs
  (:require [quuppa.ui.util :as util]))

(defn breadcrumbs
  "https://getbootstrap.com/docs/5.2/components/breadcrumb/"
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)]
    [:nav
     {:aria-label "breadcrumb"}
     (into [:ol.breadcrumb props]
           children)]))

(defn breadcrumb-item
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[{:keys [class]} children] (util/parse-args args)]
    (into [:li.breadcrumb-item
           {:class class}]
          children)))

(defn breadcrumb-current
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[{:keys [class]} children] (util/parse-args args)]
    (into [:li.breadcrumb-item.text-muted
           {:aria-current "page"
            :class class}]
          children)))
